import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { FlexContainers, Input, TextEditor } from "../../../../../components";
import { LanguageSelectorTemplate } from "../../../../../templates";
import { t } from "../../../../../services";
import { strCode } from "../../../../../consts";
import { ConsentTextEditorWrapper } from "../../styled";

const ConsentTextInput = ({
  languageList,
  setLanguageList,
  hasError,
  viewOnlyLangs = [],
  isEditDisabled
}) => {
  const [selectedId, setSelectedId] = useState(0);
  const [activeText, setActiveText] = useState("");
  const [activeTitle, setActiveTitle] = useState("");
  const [isViewOnlyText, setIsViewOnlyText] = useState(false);

  useEffect(() => {
    updateActiveText(languageList, selectedId);
  }, [selectedId, languageList.length, viewOnlyLangs.length]);

  const updateActiveText = (languages, languageId) => {
    const language = languages.find((lang) => lang.id === languageId);

    setActiveText(language?.text);
    setActiveTitle(language?.consentTitle);
    setIsViewOnlyText(viewOnlyLangs.includes(language?.title));
  };

  const onChangeLanguageCallback = (id) => {
    updateActiveText(languageList, id);
  };

  const onChangeTitle = (consentTitle) => {
    const selectedLangIdx = languageList.findIndex((lang) => lang.id === selectedId);

    const newItems = [
      ...languageList.slice(0, selectedLangIdx),
      { ...languageList[selectedLangIdx], consentTitle },
      ...languageList.slice(selectedLangIdx + 1)
    ];

    setActiveTitle(consentTitle);
    setLanguageList(newItems);
  };

  const onChangeText = (text) => {
    const selectedLangIdx = languageList.findIndex((lang) => lang.id === selectedId);

    const newItems = [
      ...languageList.slice(0, selectedLangIdx),
      { ...languageList[selectedLangIdx], text },
      ...languageList.slice(selectedLangIdx + 1)
    ];

    setLanguageList(newItems);
  };

  return (
    <LanguageSelectorTemplate
      languageList={languageList}
      setLanguageList={setLanguageList}
      selectedId={selectedId}
      setSelectedId={setSelectedId}
      viewOnlyLangs={viewOnlyLangs}
      isEditDisabled={isEditDisabled}
      onAddLanguageCallback={onChangeLanguageCallback}
      onEditLanguageCallback={onChangeLanguageCallback}>
      <ConsentTextEditorWrapper
        isViewOnly={isViewOnlyText}
        Container={FlexContainers.FlexColumnStart}
        gap={16}
        width="100%">
        <Input
          id={selectedId}
          title={t(strCode.TITLE)}
          placeholder={t(strCode.TITLE)}
          warningMsg={t(strCode.OPTIONAL_INFO)}
          disabled={isViewOnlyText}
          value={activeTitle}
          setValue={onChangeTitle}
        />

        <TextEditor
          title={t(strCode.BODY)}
          initialHtmlMarkup={activeText}
          selectedId={selectedId}
          onChange={onChangeText}
          hasError={hasError}
          viewOnly={isViewOnlyText}
        />
      </ConsentTextEditorWrapper>
    </LanguageSelectorTemplate>
  );
};

ConsentTextInput.propTypes = {
  languageList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })
  ),
  setLanguageList: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  viewOnlyLangs: PropTypes.arrayOf(PropTypes.string),
  isEditDisabled: PropTypes.bool
};

export default ConsentTextInput;
